<template>
    <div class="row align-items-end">
        <div class="col-md-2 mb-1 mb-md-0">
            <label class="form-label">Şube</label>
            <v-select-list :options="branches" label="Name" v-model="branch" placeholder="TÜMÜ"></v-select-list>
        </div>
        <div class="col-md-2 mb-1 mb-md-0">
            <label class="form-label">Organizasyonel Konum</label>
            <v-select-list :options="c_collarStatuses" label="name" v-model="collarStatus" placeholder="TÜMÜ"></v-select-list>
        </div>
        <div class="col-auto">
            <button class="btn btn-secondary" v-on:click="$emit('filter',filterData)">Filtrele</button>
        </div>
        <div class="col-auto">
            <button class="btn btn-dark" v-on:click="clearForm">Temizle</button>
        </div>
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data'
import CompanyApi from '@/api/company'

export default {
    data(){
        return{
            branches:[],
            collarStatuses:[],
            filterData:{
                BranchId:null,
                Driver:null
            }
        }
    },
    mounted(){
        this.getCollarStatuses()
        this.getBranches()
    },
    methods:{
        clearForm(){
            this.filterData.BranchId = null
            this.filterData.Driver = null
            this.$emit('filter',this.filterData)
        },
        getCollarStatuses(){
            SystemDataApi.CollarStatus().then(res=>{
                this.collarStatuses = res.data.Data
            })
        },
        getBranches(){
            CompanyApi.Branch.ListByCode("O").then(res=>{
                this.branches = res.data.Data
            })
        },
    },
    computed:{
        c_collarStatuses(){
            return [
                {name:this.collarStatuses.find(c=>c.Code == 'Driver')?.Name || '',driver:true},
                {name:this.collarStatuses.filter(c=> c.Code != 'Driver' && c.Code != '-').map(c=>c.Name).join(' - '),driver:false}
            ]
        },
        branch:{
            get:function(){
                return this.branches.find(b=>b.Id==this.filterData.BranchId)
            },
            set:function(value){
                this.filterData.BranchId = value?.Id || null
            }
        },
        collarStatus:{
            get:function(){
                return this.c_collarStatuses.find(b=>b.driver==this.filterData.Driver)
            },
            set:function(value){
                this.filterData.Driver = value?.driver != null ? value.driver : null
            }
        },
    }
}
</script>